
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function AnorexiaNervosa(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-06-anorexia-nervosa-page"}>
            <>
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Anorexia Nervosa"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Anorexia nervosa — often simply called anorexia —
                                    is an eating disorder characterized by an
                                    abnormally low body weight, an intense fear of
                                    gaining weight and a distorted perception of
                                    weight. People with anorexia place a high value on
                                    controlling their weight and shape, using extreme
                                    efforts that tend to significantly interfere with their
                                    lives.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Anorexia-nervosa/1.png")} alt="anorexianervosa" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Whole body: </b>
                                            <br />
                                            dehydration, dizziness, fainting, fatigue, low blood pressure,
                                            low body temperature, osteoporosis, water-electrolyte imbalance,
                                            or feeling cold
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Behavioural: </b>
                                            <br />
                                            binge eating, compulsive behaviour, hyperactivity, impulsivity,
                                            or social isolation
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Weight: </b>
                                            <br />
                                            underweight, weight loss, or extreme weight loss and thinness
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Mood: </b>
                                            <br />
                                            anxiety, apprehension, or guilt
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Gastrointestinal: </b>
                                            <br />
                                            constipation or vomiting
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Menstrual: </b>
                                            <br />
                                            irregular menstruation or absence of menstruation
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Developmental: </b>
                                            <br />
                                            delayed puberty or slow growth
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common: </b>
                                            <br />
                                            brittle nails, bruising, depression, dieting, dry hair, dry
                                            skin, headache, sensitivity to cold, or slow heart rate
                                        </p>
                                    </li>
                                </ul>
                              
                                <a
                                    className="links"
                                    href="https://en.wikipedia.org/wiki/Anorexia_nervosa"
                                >
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </PageWrapper>
    );
}

export default AnorexiaNervosa;